const zhongBiaoType = [
    {
        label: '中标价',
        value: 0,
    },
    {
        label: '下浮率',
        value: 1,
    },
    {
        label: '其他',
        value: 2,
    },
]

const getZhongBiaoTypeName = function (key) {
    const exist = zhongBiaoType.find((t) => t.value === key)
    return exist ? exist.label : ''
}

module.exports = {
    zhongBiaoType,
    getZhongBiaoTypeName,
}
